<template>
	<div class="account-switch" :class="{ active: accountMenuOpen }">
		<div class="links">
			<div v-if="canSearch" class="input-container">
				<div class="input-box"><input type="text" v-model="search" ref="search" placeholder="Search"></div>
			</div>
			<a v-for="acct in masterAccounts" @click.prevent="onClick($event, acct)" :key="acct.id" class="link" :class="{ active: acct.id === currentAccount.id, accent: acct.master }">{{ acct.name }}<span class="fa fa-chevron-right pointer"></span></a>
			<a v-for="acct in filteredAccounts" @click.prevent="onClick($event, acct)" :key="acct.id" class="link" :class="{ active: acct.id === currentAccount.id, accent: acct.master }">{{ acct.name }}<span class="fa fa-chevron-right pointer"></span></a>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import { mapState, mapGetters } from 'vuex';

export default {

	data() {
		return {
			search: '',
		};
	},

	computed: {
		...mapGetters([ 'accounts', 'currentAccount' ]),

		...mapState({
			accountMenuOpen: state => state.layout.accountMenuOpen
		}),

		sortedAccounts() {
			return _.sortBy(this.accounts, (account) => (account.name + '').toLowerCase());
		},

		filteredAccounts() {
			let accounts = this.sortedAccounts.filter(account => account.is_active && !account.master);

			if (!this.search || this.search.length === 0) return accounts;

			return accounts.filter(account => {
				return account.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
			});
		},

		masterAccounts() {
			return this.sortedAccounts.filter(account => this.$root.isSuperAdmin && account.master);
		},

		canSearch() {
			return this.sortedAccounts.length >= 5;
		}

	},

	watch: {

		accountMenuOpen(isOpen) {
			if (isOpen && this.$refs.search) {
				this.$refs.search.focus();
			}
		},

	},

	methods: {

		accountIcon(account) {
			if (this.currentAccount.id === account.id) {
				return '';
			}

			return null;
		},

		onClick(e, account) {
			if (account.id === this.currentAccount.id) {
				return this.$store.dispatch('closeAccountMenu');
			}

			this.$router.push(`/account/${ account.id }/switch`);
		}

	},

};

</script>
